import {
  EyeOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  PlusOutlined,
  SearchOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Input,
  Menu,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
  message,
} from 'antd';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useEffect, useMemo, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { ReactComponent as Archive } from '../../Images/archive.svg';
import { ReactComponent as Archiveicon } from '../../Images/Archiveicon.svg';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import { ReactComponent as EditIcon } from '../../Images/EditIcon.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import {
  deleteConversionRate,
  fetchConversionRateList,
  resetConversionRateList,
} from '../../slices/conversion-rate';
import ImportDataModal from '../../Common/ImportDataModal';
import { debounce } from 'lodash';
import { fetchAndSetIpAddress } from '../../slices/ipSlice';
import { createActivityLog } from '../../slices/activity-log';
import logo from '../../Images/alux-logo.png';
import formatFile from "../../Images/sample-files/conversion-rate-format.xlsx";
export default function ConversionRateList() {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user: currentUser } = useSelector(state => state.auth);
  const { data = [], status } = useSelector(state => state.conversionRate);
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(5000);
    const [open, setOpen] = useState(false);
  const [search, setSearch] = useState(
    localStorage.getItem('die_text_search_converstionRate') || ''
  );
  const [inputValue, setInputValue] = useState(
    localStorage.getItem('die_text_search_converstionRate') || ''
  );
  const [checkedList, setCheckedList] = useState([
    'SrNo',
    'customer',
    'created_at',
    'created_by',
    'updated_at',
    'updated_by',
    'action',
  ]);

  const ipAddress = useSelector(state => state.ip.ipAddress);

  useEffect(() => {
    if (!ipAddress) {
      dispatch(fetchAndSetIpAddress());
    }
  }, [ipAddress, dispatch]);

  useEffect(() => {
    dispatch(
      fetchConversionRateList({
        page,
        pagesize: 5000,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      })
    );
  }, [dispatch, page, pagesize, search, orderBy]);

  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };
const refreshTable = () => {
    dispatch(resetConversionRateList());
    dispatch(
      fetchConversionRateList({
        page: 1,
        pagesize,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      })
    );
  };
  const handleEdit = id => {
    navigate(`/edit-conversion-rate/${id}`);
  };

  const handleDelete = id => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }
    dispatch(deleteConversionRate(id))
      .unwrap()
      .then(() => {
        message.success('Conversion Rate Item Archived Successfully!');
        dispatch(fetchConversionRateList({ page, pagesize, search, ordering: orderBy }));
      })
      .catch(error => {
        const errorMessage =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'An unknown error occurred.';
        message.error(errorMessage);
      });
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: selectedKeys => {
      setSelectedRowKeys(selectedKeys);
    },
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: 100,
      sorter: false,
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer',
      key: 'customer',
      sorter: true,
      render: customer => <span>{customer || 'N/A'}</span>,
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: true,
      width: 150,
      render: (text, record) => {
        return (
          <span>
            {record?.created_at
              ? dayjs(record.created_at).format('DD-MM-YYYY HH:mm')
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      sorter: true,
      width: 150,
      render: (text, record) => {
        const createdBy = record?.created_by;
        if (createdBy && typeof createdBy === 'object') {
          return (
            <span>
              {createdBy.first_name || ''} {createdBy.last_name || ''}
            </span>
          );
        }
        return <span>N/A</span>;
      },
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      sorter: true,
      width: 150,
      render: (text, record) => {
        return (
          <span>
            {record?.updated_at
              ? dayjs(record.updated_at).format('DD-MM-YYYY HH:mm')
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Updated By',
      dataIndex: 'updated_by',
      key: 'updated_by',
      sorter: true,
      width: 150,
      render: (text, record) => {
        const updatedBy = record?.updated_by;
        if (updatedBy && typeof updatedBy === 'object') {
          return (
            <span>
              {updatedBy.first_name || ''} {updatedBy.last_name || ''}
            </span>
          );
        }
        return <span>N/A</span>;
      },
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'action',
      render: (_, record) => (
        <Space>
          {/* {currentUser.permissions.permissions.die.includes(
                'view_onversionrate',
              ) && ( */}
          <Tooltip placement="top" title={'View Conversion Rate'}>
            <Link to={`/view-conversion-rate/${record.customer_id}`}>
              <EyeOutlined style={{ fontSize: '17px' }} />
            </Link>
          </Tooltip>
          {/* )} */}
          {currentUser.permissions.permissions.die.includes('change_conversionrate') && (
            <Tooltip placement="top" title="Edit">
              <span onClick={() => handleEdit(record.customer_id)}>
                <EditIcon style={{ cursor: 'pointer' }} />
              </span>
            </Tooltip>
          )}
          {currentUser.permissions.permissions.die.includes('delete_conversionrate') && (
            <Link>
              <Tooltip title="Archive">
                <Popconfirm
                  title="Are you sure you want to archive this record?"
                  onConfirm={() => handleDelete(record.id)}
                  onCancel={() => message.info('Action cancelled')}
                  okText="Yes"
                  cancelText="No"
                >
                  <Archive style={{ cursor: 'pointer' }} />
                </Popconfirm>
              </Tooltip>
            </Link>
          )}
        </Space>
      ),
    },
  ];

  const filteredColumns = columns.filter(column => checkedList.includes(column.key));
  const handlePageSizeChange = (current, size) => {
    setPage(1);
    setPageSize(size);
  };

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group value={checkedList} onChange={handleColumnVisibilityChange}>
          <Row>
            <Col span={12}>
              <Checkbox value="SrNo" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="customer">Customer Name</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="created_at">Created At</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="created_by">Created By</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="updated_at">Updated At</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="updated_by">Updated By</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const [dropdownVisible, setDropdownVisible] = useState(false);

  const dataSource = useMemo(() => {
    const seenCustomers = new Set();
    return data
      .filter(item => {
        if (seenCustomers.has(item.customer)) {
          return false;
        }
        seenCustomers.add(item.customer);
        return true;
      })
      .map((item, index) => ({
        ...item,
        key: item.id,
        SrNo: (page - 1) * pagesize + index + 1,
      }));
  }, [data, page, pagesize]);

  const filteredTotal = useMemo(() => {
    const seenCustomers = new Set();
    return data.filter(item => {
      if (seenCustomers.has(item.customer)) {
        return false;
      }
      seenCustomers.add(item.customer);
      return true;
    }).length;
  }, [data]);

  const debouncedAPICall = useMemo(
    () =>
      debounce(query => {
        if (query.length >= 3 || query.length === 0) {
          setSearch(query);
          localStorage.setItem('die_text_search_converstionRate', query);
          setPage(1);
        }
      }, 500),
    []
  );

  useEffect(() => {
    return () => {
      debouncedAPICall.cancel();
    };
  }, [debouncedAPICall]);

  const handleSearch = e => {
    const value = e.target.value;
    setInputValue(value);
    debouncedAPICall(value);
  };

  const handlePageChange = newPage => {
    setPage(newPage);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    const sortingMap = {
      customer: { ascend: 'customer', descend: '-customer' },
    };
    return sortingMap[sortField]?.[sortOrder] || '';
  };

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const orderByValue = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderByValue);
    } else {
      setOrderBy('');
    }
    if (pagination?.pageSize) setPageSize(pagination.pageSize);
    if (pagination?.current) setPage(pagination.current);
  };
  const resetFilter = () => {
    setSearch('');
    setInputValue('');
    setOrderBy('');
    localStorage.removeItem('die_text_search_converstionRate');
    localStorage.removeItem('die_group_search_converstionRate');
    setPage(1);
  };

  const exportPDF = () => {
    const pdf = new jsPDF('l', 'pt', 'a4');

    const pdfColumns = [
      { header: 'Sr No.', dataKey: 'SrNo' },
      { header: 'Customer Name', dataKey: 'customer' },
      { header: 'Created At', dataKey: 'created_at' },
      { header: 'Created By', dataKey: 'created_by' },
      { header: 'Updated At', dataKey: 'updated_at' },
      { header: 'Updated By', dataKey: 'updated_by' },
    ];

    const pdffilteredColumns = pdfColumns.filter(column =>
      checkedList.includes(column.dataKey)
    );

    const rows = dataSource.map((item, index) => ({
      SrNo: index + 1,
      customer: item.customer || 'N/A',
      created_at: item.created_at
        ? dayjs(item.created_at).format('DD-MM-YYYY HH:mm')
        : 'N/A',
      created_by:
        item.created_by && typeof item.created_by === 'object'
          ? `${item.created_by.first_name || ''} ${item.created_by.last_name || ''}`
          : 'N/A',
      updated_at: item.updated_at
        ? dayjs(item.updated_at).format('DD-MM-YYYY HH:mm')
        : 'N/A',
      updated_by:
        item.updated_by && typeof item.updated_by === 'object'
          ? `${item.updated_by.first_name || ''} ${item.updated_by.last_name || ''}`
          : 'N/A',
    }));

    const pageWidth = pdf.internal.pageSize.width;
    pdf.setFont('times', 'bold');
    pdf.setFontSize(16);
    const headingText = 'Conversion Rate List';
    const headingX = pageWidth / 2 - pdf.getTextWidth(headingText) / 2;
    pdf.text(headingText, headingX, 40);

    pdf.autoTable({
      columns: pdffilteredColumns,
      body: rows,
      startY: 80,
      theme: 'grid',
      margin: { top: 80, right: 30, left: 30, bottom: 40 },
      styles: {
        font: 'times',
        halign: 'center',
        overflow: 'linebreak',
        cellPadding: 3.8,
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
      },
      headStyles: {
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        fillColor: false,
      },
      didDrawPage: data => {
        const pageCount = pdf.internal.getNumberOfPages();
        const pageSize = pdf.internal.pageSize;

        // ✅ Add logo only on the first page (top-right)
        if (data.pageNumber === 1) {
          pdf.addImage(logo, 'PNG', pageSize.getWidth() - 100, 10, 90, 30);
        }

        // ✅ Footer: Date & Time (left) + Page number (right)
        pdf.setFontSize(8);
        const dateStr = new Date().toLocaleString();

        pdf.text(
          dateStr,
          30,
          pageSize.getHeight() - 20
        );

        pdf.text(
          `Page ${data.pageNumber} of ${pageCount}`,
          pageSize.getWidth() - 80,
          pageSize.getHeight() - 20
        );
      },
      willDrawCell: data => {
        if (data.cell.text.length > 0) {
          const text = data.cell.text[0];
          if (text && text.length > 30) {
            data.cell.text[0] = text.substring(0, 27) + '...';
          }
        }
      },
    });

    pdf.save(`conversion_rate_${new Date().toISOString().split('T')[0]}.pdf`);

    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Conversion Rate',
        ip_address: ipAddress,
        description: 'Conversion rate PDF downloaded successfully!',
      })
    );
  };


  const activityLog = () => {
    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Conversion Rate',
        ip_address: ipAddress,
        description: 'Conversion rate Excel downloaded successfully!',
      })
    );
  };

  const csvheaders = [
    { label: 'Sr No.', key: 'SrNo' },
    { label: 'Customer Name', key: 'customer' },
    { label: 'Created At', key: 'created_at' },
    { label: 'Created By', key: 'created_by' },
    { label: 'Updated At', key: 'updated_at' },
    { label: 'Updated By', key: 'updated_by' },
  ];

  const csvFilterheaders = csvheaders.filter(column =>
    checkedList.includes(column.key)
  );

  const csvListData = dataSource.map((item, index) => ({
    SrNo: index + 1,
    customer: item.customer || 'N/A',
    created_at: item.created_at
      ? dayjs(item.created_at).format('DD-MM-YYYY HH:mm')
      : 'N/A',
    created_by:
      item.created_by && typeof item.created_by === 'object'
        ? `${item.created_by.first_name || ''} ${item.created_by.last_name || ''}`
        : 'N/A',
    updated_at: item.updated_at
      ? dayjs(item.updated_at).format('DD-MM-YYYY HH:mm')
      : 'N/A',
    updated_by:
      item.updated_by && typeof item.updated_by === 'object'
        ? `${item.updated_by.first_name || ''} ${item.updated_by.last_name || ''}`
        : 'N/A',
  }));

  return (
    <div className="mainwrap">
      <div className="sticyaction">
        <Row className="pagenamerow mb-0" justify="space-between" align="middle">
          <Col>
            <h2>Conversion Rates</h2>
            <div className="bredcrumbwrp">
              <Link to="/customer-list" className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  //{ title: <Link to="/customer-list">Customers</Link> },
                   { title: <Link to="/dashboard">Home</Link> },
                  { title: 'Conversion Rates' },
                ]}
              />
            </div>
          </Col>
          <Col>
            <Space size="small">
              <Input
                placeholder="Search"
                className="searchbox"
                prefix={<SearchOutlined />}
                value={inputValue}
                style={{ width: 200 }}
                onChange={handleSearch}
              />
              <Tooltip title="Reset Filters">
                <Button
                  type="primary"
                  disabled={!search && !orderBy}
                  className="iconlink"
                  onClick={resetFilter}
                >
                  <FilterIcon />
                </Button>
              </Tooltip>

              {currentUser.permissions.permissions.die.includes(
                'download_conversion_rate_excel_copy'
              ) && (
                  <Tooltip placement="top" title="Export Excel">
                    <Button type="primary" className="iconlink" onClick={activityLog}>
                      <CSVLink
                        filename={`conversion_rate_${new Date().toISOString().split('T')[0]}.csv`}
                        data={csvListData}
                        headers={csvFilterheaders}
                      >
                        <FileExcelOutlined />
                      </CSVLink>
                    </Button>
                  </Tooltip>
                )}
              {currentUser.permissions.permissions.die.includes(
                'download_conversion_rate_pdf_copy'
              ) && (
                  <Tooltip placement="top" title="Export PDF">
                    <Button type="primary" className="iconlink" onClick={exportPDF}>
                      <FilePdfOutlined />
                    </Button>
                  </Tooltip>
                )}
              {currentUser.permissions.permissions.die.includes('add_conversionrate') && (
                <Link to="/add-conversion-rate">
                  <Tooltip title="Add Conversion Rate Item">
                    <Button type="primary" icon={<PlusOutlined />}>
                      Add Conversion Rate Item
                    </Button>
                  </Tooltip>
                </Link>
              )}
                 {/* <Button type="primary" icon={<UploadOutlined  />} onClick={() => setOpen(true)}>
                Import Data
              </Button> */}
              {currentUser.permissions.permissions.die.includes('delete_conversionrate') && (
                <Link to="/archive-conversion-rat-list" className="iconlink">
                  <Tooltip title="Archive">
                    <Archiveicon />
                  </Tooltip>
                </Link>
              )}
              {currentUser.permissions.permissions.die.includes('view_conversionrate') && (
                <Tooltip title="View Rate List">
                  <Button type="primary" onClick={() => navigate('/view-conversion-rate-list')}>
                    View Rate List
                  </Button>
                </Tooltip>
              )}
              <Dropdown
                overlay={columnMenu}
                open={dropdownVisible}
                onOpenChange={setDropdownVisible}
              >
                <Button type="primary" icon={<ColumnList />} />
              </Dropdown>
            </Space>
          </Col>
        </Row>
      </div>
      <ImportDataModal
        open={open}
        onClose={() => setOpen(false)}
        refreshTable={refreshTable}
        formatFilePath={formatFile}
        model={"conversionrate"}
      />
      <div className="tablewrp">
        <Table
          rowKey="id"
          columns={filteredColumns}
          dataSource={dataSource}
          loading={status === 'loading'}
          onChange={handleTableChange}
          scroll={{ x: '600px' }}
          pagination={false}
        />
      </div>
    </div>
  );
}